<script setup lang="ts">
import { formatSuggestionScore } from '~~/shared/utils/suggestions'

interface Props {
  score: number
}

defineProps<Props>()
</script>

<template>
  <!-- Positive scores are green with a plus, negative red, zero neutral -->
  <span
    class="font-semibold tabular-nums"
    :class="score > 0 ? 'text-success' : score < 0 ? 'text-error' : 'text-muted'"
  >
    {{ formatSuggestionScore(score) }}
  </span>
</template>
